<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Transportation" class="d-icon d-icon--transportation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M3 2a.5.5 0 0 0-.5.5V5h3V2H3Zm0-1a1.5 1.5 0 0 0-1.5 1.5v6A1.5 1.5 0 0 0 3 10h.066l-.482.723a.5.5 0 0 0 .832.555L4.268 10h3.465l.851 1.277a.5.5 0 1 0 .832-.555L8.934 10H9a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 9 1H3Zm3.5 1v3h3V2.5A.5.5 0 0 0 9 2H6.5Zm3 4h-7v2.5A.5.5 0 0 0 3 9h6a.5.5 0 0 0 .5-.5V6Zm-6 1.5A.5.5 0 0 1 4 7h.005a.5.5 0 1 1 0 1H4a.5.5 0 0 1-.5-.5Zm4 0A.5.5 0 0 1 8 7h.005a.5.5 0 1 1 0 1H8a.5.5 0 0 1-.5-.5Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconTransportation',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
